function productCartApp() {
  return {
    show: false,
    items: [],
    init() {
      document.addEventListener('addedToCart', (e) => {
        this.items = e.detail.items;
        this.show = true;
      });
    },
    closePopup() {
      this.show = false;
      this.items = [];
    },
    isPublicProperty(propId) {
      return propId.charAt(0) != '_';
    },
  };
}
